var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","width":"100%"}},[_c('LineChartGenerator',{attrs:{"options":_vm.chartOptions,"data":_vm.display}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }